<template>
  <div class="flex w-full h-full">
    <div class="flex flex-col items-center justify-center w-full min-h-full" v-if="!port || !getContacts.length">
      <svg width="320" height="160" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M148.625 89.938h-.001a1.02 1.02 0 00-.193-.02 1.745 1.745 0 00-.273.016v.248l.001.14c0 3.985-1.779 7.682-4.871 10.142l-2.783 2.213-2.79-2.216-.001-.001c-3.056-2.422-4.872-6.206-4.872-10.138a.397.397 0 00-.148-.313l-.004-.003-.004-.003a.353.353 0 00-.303-.067l-.007.002c-3.729.855-7.408 2.3-10.938 4.31-4.033 2.299-6.541 6.638-6.541 11.325v19.11c0 .228.182.399.382.399h50.442c.2 0 .382-.171.382-.399v-19.11c.001-4.687-2.507-9.026-6.541-11.325-3.526-2.01-7.206-3.454-10.937-4.31zm-28.117 2.638c3.681-2.096 7.533-3.61 11.448-4.509a2.231 2.231 0 011.925.447c.543.44.858 1.102.858 1.808 0 3.346 1.55 6.572 4.146 8.629l1.619 1.287 1.612-1.281c2.635-2.097 4.146-5.238 4.146-8.634v-.144c-.003-.657-.006-1.299.5-1.71.537-.447 1.595-.56 2.283-.401 3.918.898 7.769 2.413 11.448 4.509 4.63 2.639 7.508 7.617 7.507 12.996v19.11c0 1.277-1.021 2.317-2.279 2.317h-50.442c-1.258 0-2.279-1.039-2.279-2.317v-19.11c0-5.38 2.877-10.358 7.508-12.996zM128.622 71.47l.191.728c.53 2.026 1.665 4.58 3.512 6.589 1.808 1.967 4.273 3.4 7.633 3.4h.059c.157.005.316.005.451 0h.064c6.709 0 10.228-5.77 11.39-10l.196-.716.615-.414c1.881-1.267 2.545-2.706 2.794-3.665l.001-.003c.504-1.927-.128-3.736-.585-4.673l-.2-.411-.011-2.532.001-.033c.017-.576.011-1.12-.008-1.62l-.003-.072.003-.072c.125-3.745-1.302-6.276-2.771-7.91-1.427-1.586-2.896-2.318-3.006-2.373l-.005-.003-.04-.017-.038-.02c-4.312-2.125-7.894-2.193-10.676-1.437-2.829.77-4.968 2.43-6.254 3.941l-.519.61-.797.084a4.18 4.18 0 00-2.277.963c-1.463 1.23-2.456 3.667-2.331 7.847l.001.034-.011 2.605-.197.408c-.458.952-1.09 2.755-.587 4.683.248.954.91 2.39 2.782 3.656l.623.422zm-1.564-21.19a6.185 6.185 0 013.353-1.418c3.009-3.538 9.886-7.663 19.338-3.002.254.112 7.266 3.478 6.975 12.183.02.542.026 1.13.008 1.754l.009 2.042c.545 1.119 1.403 3.455.722 6.056-.357 1.372-1.279 3.249-3.613 4.82-1.237 4.509-5.215 11.471-13.318 11.471-.179.006-.38.006-.574 0-8.024 0-11.899-6.962-13.08-11.482-2.322-1.572-3.241-3.443-3.597-4.808-.678-2.602.18-4.933.722-6.057l.009-2.118c-.133-4.432.892-7.634 3.046-9.44z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M236 34H99c-5.523 0-10 4.477-10 10v85.13c0 5.523 4.477 10 10 10h137c5.523 0 10-4.477 10-10V44c0-5.523-4.477-10-10-10zM99 32c-6.627 0-12 5.373-12 12v85.13c0 6.627 5.373 12 12 12h137c6.627 0 12-5.373 12-12V44c0-6.627-5.373-12-12-12H99z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M72 31c0-7.18 5.82-13 13-13h137c7.18 0 13 5.82 13 13v1h-2v-1c0-6.075-4.925-11-11-11H85c-6.075 0-11 4.925-11 11v85.13c0 6.075 4.925 11 11 11h2.5v2H85c-7.18 0-13-5.821-13-13V31z" fill="#DEE3EA"/><path fill-rule="evenodd" clip-rule="evenodd" d="M186.373 60.968a1 1 0 011-1h42.439a1 1 0 010 2h-42.439a1 1 0 01-1-1zm0 17.919a1 1 0 011-1h42.439a1 1 0 010 2h-42.439a1 1 0 01-1-1zm0 17.066a1 1 0 011-1h42.439a1 1 0 010 2h-42.439a1 1 0 01-1-1zm0 16.212a1 1 0 011-1h22.7a1 1 0 010 2h-22.7a1 1 0 01-1-1z" fill="#DEE3EA"/></svg>
      <h1 class="m-t-4 m-b-2 fz18 fw500">Contacts is empty</h1>
      <button class="fz14 text-blue" @click="isModalAdd = true">Create new</button>
    </div>

    <div class="w-5/12 overflow-y-auto box-border border-r border-gray-light bg-white" v-if="port && getContacts.length">
      <aside-top :name="port.name" @on-add="isModalAdd = true"/>
      <aside-list 
        :list="getContacts" 
        :active="active" 
        @on-select="onSelectContact"
        @on-archive="onArchive"
      />
    </div>
    <div class="w-7/12 overflow-y-auto box-border" v-if="port && getContacts.length">
      <div class="flex items-center justify-between p-x-6 p-y-4">
        <h2 class="fz18 fw500">Contacts Details</h2>
        <div class="fz13 text-gray-text" v-if="active">Last edit {{active.updated_at | formatDate}} at {{active.updated_at | formatTime}} {{active.creator && typeof active.creator == 'object' ? 'by '+active.creator.first_name+' '+active.creator.last_name : ''}}</div>
        <div class="fz13 text-gray-text" v-else>Please, choose the contact</div>
      </div>

      <contact class="m-x-6 m-b-4" v-if="active" :contact="active" @on-update="onUpdate" @on-error="onError"/>
    </div>

    <add-modal
      v-if="isModalAdd"
      :isShowModal="isModalAdd"
      @on-close="isModalAdd = false"
      @on-add="onAdd"
    />

    <archive-modal 
      :isShowModal="isModalArchive"
      :contact="archivedContact"
      @on-close="onCloseModal"
      @on-send="sendArchive"
    ></archive-modal>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'

import addModal from '@/components/ports/contacts/add'
import asideTop from '@/components/ports/contacts/asideTop'
import asideList from '@/components/ports/contacts/asideList'
import contact from '@/components/ports/contacts/contact'
import archiveModal from '@/components/ports/contacts/modal'

export default {
  components: {
    addModal,
    asideTop,
    asideList,
    contact,
    archiveModal
  },
  data() {
    return {
      active: null,
      isModalAdd: false,
      isModalArchive: false,
      archivedContact: null,
      isError: false
    }
  },
  computed: {
    ...mapState({
      port: state => state.ports.openPort
    }),
    getContacts() {
      if(!this.port || !this.port.contacts.length) return []
      return this.port.contacts.filter(el=>!el.is_archive)
    }
  },
  methods: {
    ...mapActions(['axiosEditContact']),
    ...mapMutations(['addTip']),
    onSelectContact(contact) {
      if(this.isError) return false
      this.active = contact
    },
    onError(bool) {
      this.isError = bool
    },
    onAdd(contact) {
      this.port.contacts.unshift(contact)
    },
    async onUpdate(contact) {
      if(this.isError) return false

      if(contact.port.id)
        contact.port = contact.port.id
      
      let newContact = await this.axiosEditContact({...contact})

      let index = this.port.contacts.findIndex(el=>{
        return el.id == newContact.id
      })
      this.port.contacts.splice(index, 1, newContact)
      this.active = newContact
    },
    onCloseModal() {
      this.isModalArchive = false
      this.archivedContact = null
    },
    onArchive(contact) {
      if(this.isError && this.active && contact.id == this.active.id) return false
      this.archivedContact = contact
      this.isModalArchive = true
    },
    async sendArchive() {
      this.archivedContact.is_archive = true
      this.onUpdate(this.archivedContact)
      this.addTip(`Contact is archived`)
      if(this.active && this.active.id == this.archivedContact.id){
        if(this.getContacts.length) this.active = this.getContacts[0]
        else this.active = null
      }
      this.archivedContact = null
      this.isModalArchive = false
    }
  },
  beforeMount() {
    // console.log('lol1', this.getContacts);
    if(!this.active)
      this.onSelectContact(this.getContacts[0])
  }
}
</script>

<style lang="scss">
</style>